import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { PostComments } from '../../pages/PostComments';
import { Header } from '../../components/Header';
import { useNotificationOpenTracking } from '@/lib/hooks/useUserNotifications';

const postCommentsSearchSchema = z.object({
  notificationId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/feed/$postId')({
  validateSearch: postCommentsSearchSchema,
  component: PostCommentsPage,
});

function PostCommentsPage() {
  const { postId } = Route.useParams();
  const { notificationId } = Route.useSearch();
  const navigate = useNavigate();
  const postIdNum = parseInt(postId, 10);

  useNotificationOpenTracking(notificationId, () => {
    navigate({
      to: '/feed/$postId',
      params: { postId },
      replace: true,
    });
  });

  if (isNaN(postIdNum)) {
    return (
      <>
        <Header enableBack />
        <div className="flex justify-center items-center py-12">
          <p className="text-body text-foreground/60">Invalid post ID</p>
        </div>
      </>
    );
  }

  return (
    <div className="flex flex-col">
      <Header enableBack additionalClasses="bg-slate-600" />
      <PostComments postId={postIdNum} />
    </div>
  );
}
